import { SettingMessages, TranslationSettingMessages } from "@languages/interfaces";

// eslint-disable-next-line import/prefer-default-export
export const messages: TranslationSettingMessages = {
  [SettingMessages.settingTitlePage]: "Configurações",
  [SettingMessages.settingDeleteOptionTitle]: "Excluir Conta",
  [SettingMessages.settingChangePasswordOptionTitle]: "Alterar Senha",
  [SettingMessages.settingLoginVerificationFailed]: `Falha ao verificar senha, confira sua senha atual e 
  tente novamente`,
  [SettingMessages.settingParamsTitle]: "Parâmetros",
  [SettingMessages.settingColorsTitle]: "Cores",
  [SettingMessages.settingIconsTitle]: "Ícones",
  [SettingMessages.settingParamsMinDaysDescription]: "Dias mínimos para solicitação de programação",
  [SettingMessages.settingParamsDaysLabel]: "Dias",
  [SettingMessages.settingColorsPrimary]: "Cor primária",
  [SettingMessages.settingColorsSecondary]: "Cor secundária",
  [SettingMessages.settingColorsTertiary]: "Cor terciária",
  [SettingMessages.settingsColorsDisable]: "Cor de inatividade",
  [SettingMessages.settingsColorsLoginBackground]: "Cor de fundo do login",
  [SettingMessages.settingEnvironmentTitle]: "Ambiente",
  [SettingMessages.settingParamsSuccessUpdate]: "Parâmetros atualizados com sucesso.",
  [SettingMessages.settingParamsNoChange]: "Nenhum parâmetro foi alterado",
  [SettingMessages.settingNotificationReload]: "Ao alterar o visual, a página será recarregada para atualizar.",
  [SettingMessages.settingColorsNoChange]: "Nenhuma cor foi alterada.",
  [SettingMessages.settingIconsNoChange]: "Nenhum ícone foi alterado."

};
